// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"VideoToolbarTop_toolbar__3lxjc","backButtonIcon":"VideoToolbarTop_backButtonIcon__1T0O8"};